/* global bootstrap */

import React, { useContext, useEffect, useState } from "react";
import LanguageContext from "../../utils/Contexts/LanguageContext";
import moment from "moment";
import "./style.css";
import { formatThousand } from "../../utils";
import Tick from "../svg/Tick";
import Cross from "../svg/Cross";
import Mark from "../svg/QuestionMak";
import { useNavigate } from "react-router-dom";

const MonitorTable = ({
  data,
  setData,
  columnsVisibility,
  setColumnSorts,
  columnSorts,
}) => {
  const { t } = useContext(LanguageContext);
  const navigate = useNavigate();
  const setColumnSort = (columnIndex) => {
    setColumnSorts((prevSorts) => ({
      ...prevSorts,
      [columnIndex]:
        prevSorts[columnIndex] === "asc"
          ? "desc"
          : prevSorts[columnIndex] === "desc"
          ? null
          : "asc",
    }));
  };
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const contractStatusType = {
    0: {
      title: t("Created"),
      class: "text-gray bg-soft-secondary",
      contractClass: "text-gray",
    },
    1: {
      title: t("Waiting Acceptance"),
      class: "text-warning bg-softer-warning",
      contractClass: "text-warning",
    },
    2: {
      title: t("Declined"),
      class: "text-orange bg-text-orange",
      contractClass: "text-orange",
    },
    3: {
      title: t("Canceled"),
      class: "text-danger bg-soft-danger",
      contractClass: "text-danger",
    },
    4: {
      title: t("In Progress"),
      class: "text-primary bg-soft-primary",
      contractClass: "text-primary",
    },
    5: {
      title: t("Canceled"),
      class: "text-danger bg-soft-danger",
      contractClass: "text-danger",
    },
    6: {
      title: t("Approved"),
      class: "text-info bg-soft-primary",
      contractClass: "text-info",
    },
    7: {
      title: t("Rejected"),
      class: "text-orange bg-text-orange",
      contractClass: "text-orange",
    },
    8: {
      title: t("Declined"),
      class: "text-orange bg-text-orange",
      contractClass: "text-orange",
    },
    9: {
      title: t("Completed"),
      class: "text-success bg-soft-success",
      contractClass: "text-success",
    },
    10: {
      title: t("Deleted"),
      class: "text-muted bg-soft-danger",
      contractClass: "text-muted",
    },
    11: {
      title: t("Canceled"),
      class: "text-danger bg-soft-danger",
      contractClass: "text-danger",
    },
    12: {
      title: t("Canceled"),
      class: "text-danger bg-soft-danger",
      contractClass: "text-danger",
    },
  };
  const statusContent = {
    false: <Cross />,
    true: <Tick />,
    null: <Cross />,
  };
  const arrowIdentificaton = (value) => {
    if (value > 0) {
      return (
        <i
          className="bi bi-arrow-up text-success"
          style={{ height: "16px !important", width: "16px !important" }}
        ></i> // Green arrow for positive change
      );
    } else if (value < 0) {
      return (
        <i
          className="bi bi-arrow-down text-danger"
          style={{ height: "16px !important", width: "16px !important" }}
        ></i> // Red arrow for negative change
      );
    } else {
      return "";
    }
  };

  const columnsHeader = [
    { key: "backlink", label: t("Backlink") },
    { key: "indexed", label: t("Indexed") },
    { key: "price", label: t("Price") },
    {
      key: "dr",
      label: t("Dr"),
      icon: <Mark height="16" width="16" fill="var(--gray)" />,
    },
    {
      key: "ur",
      label: t("Ur"),
      icon: <Mark height="16" width="16" fill="var(--gray)" />,
    },
    {
      key: "da",
      label: t("Da"),
      icon: <Mark height="16" width="16" fill="var(--gray)" />,
    },
    {
      key: "pa",
      label: t("Pa"),
      icon: <Mark height="16" width="16" fill="var(--gray)" />,
    },
    {
      key: "traffic",
      label: t("Traffic"),
      icon: <Mark height="16" width="16" fill="var(--gray)" />,
    },
    {
      key: "ext",
      label: t("Ext"),
      icon: <Mark height="16" width="16" fill="var(--gray)" />,
    },
    {
      key: "int",
      label: t("Int"),
      icon: <Mark height="16" width="16" fill="var(--gray)" />,
    },
    { key: "target", label: t("Target Page") },
    { key: "t_indexed", label: t("Indexed") },
    { key: "status", label: t("Status"), isSort: true, sortingIndex: 3 },
    { key: "anchor", label: t("Anchor"), isSort: true, sortingIndex: 0 },
    { key: "rel", label: t("Rel"), isSort: true, sortingIndex: 1 },
    { key: "type", label: t("Type"), isSort: true, sortingIndex: 2 },
    { key: "contract", label: t("Contract") },
    { key: "created", label: t("Added"), isSort: true, sortingIndex: 4 },
    { key: "first_seen", label: t("First Seen") },
    { key: "last_seen", label: t("Last Seen") },
  ];

  const columnHeaderValue = {
    backlink: {
      value: (item) => item?.backlink,
      className: (item) =>
        `${
          contractStatusType[item?.backlink]?.contractClass
        } text-decoration-underline cursor-pointer`,
      style: { fontSize: "16px", fontWeight: "400" },
    },
    indexed: {
      value: (item) => localizeDate(item?.indexed),
      className: (item) => "custom-text-gray",
      style: { fontSize: "14px !important", fontWeight: "600" },
    },
    price: {
      value: (item) => `$${item?.contract?.price}`,
      className: (item) => "custom-text-gray",
      style: { fontSize: "14px !important", fontWeight: "600" },
    },

    dr: {
      value: (item) => item?.dr || "─",
      className: (item) => "custom-text-gray",
      style: { fontSize: "14px !important", fontWeight: "600" },
    },
    ur: {
      value: (item) => item?.ur || "─",
      className: (item) => "custom-text-gray",
      style: { fontSize: "14px !important", fontWeight: "600" },
    },
    da: {
      value: (item) => item?.da || "─",
      className: (item) => "custom-text-gray",
      style: { fontSize: "14px !important", fontWeight: "600" },
    },
    pa: {
      value: (item) => item?.pa || "─",
      className: (item) => "custom-text-gray",
      style: { fontSize: "14px !important", fontWeight: "600" },
    },
    traffic: {
      value: (item) => item?.traffic || "─",
      className: (item) => "custom-text-gray",
      style: { fontSize: "14px !important", fontWeight: "600" },
    },
    ext: {
      value: (item) => item?.exit || "─",
      className: (item) => "custom-text-gray",
      style: { fontSize: "14px !important", fontWeight: "600" },
    },
    int: {
      value: (item) => item?.int || "─",
      className: (item) => "custom-text-gray",
      style: { fontSize: "14px !important", fontWeight: "600" },
    },
    target: {
      value: (item) => item?.target?.page?.title || "─",
      className: (item) => "custom-text-gray",
      style: { fontSize: "14px !important", fontWeight: "600" },
    },
    t_indexed: {
      value: (item) => item?.target?.page?.Target_indexed || "─",
      className: (item) => "custom-text-gray",
      style: { fontSize: "14px !important", fontWeight: "600" },
    },
    status: {
      value: (item) => contractStatusType[item?.status]?.title,
      className: (item) =>
        `${contractStatusType[item?.status]?.class} py-1 rounded-1`,
      style: {
        width: "157px",
        textAlign: "center",
        fontSize: "14px !important",
        fontWeight: "600",
      },
    },
    anchor: {
      value: (item) => item?.anchor || "─",
      className: (item) => "custom-text-gray",
      style: { fontSize: "14px !important", fontWeight: "600" },
    },
    rel: {
      value: (item) => item?.rel || "─",
      className: (item) => "custom-text-gray",
      style: { fontSize: "14px !important", fontWeight: "600" },
    },
    type: {
      value: (item) => item?.type || "─",
      className: (item) => "custom-text-gray",
      style: { fontSize: "14px !important", fontWeight: "600" },
    },
    contract: {
      value: (item) => {
        if (!item?.contract) return "─";
        if (typeof item.contract === "string") return item.contract;
        if (typeof item.contract === "object") {
          return item.contract.code || "─";
        }
        return "─";
      },
      className: (item) =>
        `${
          contractStatusType[item?.status]?.contractClass
        } text-decoration-underline cursor-pointer`,
      style: { fontSize: "14px !important", fontWeight: "600" },
    },
    created: {
      value: (item) => localizeDate(item?.created),
      className: (item) => "custom-text-gray",
      style: { fontSize: "14px !important", fontWeight: "600" },
    },
    first_seen: {
      value: (item) => localizeDate(item?.first_seen),
      className: (item) => "custom-text-gray",
      style: { fontSize: "14px !important", fontWeight: "600" },
    },
    last_seen: {
      value: (item) => localizeDate(item?.last_seen),
      className: (item) => "custom-text-gray",
      style: { fontSize: "14px !important", fontWeight: "600" },
    },
  };

  //   const navigateToOpenDetails = (uuid) => {
  //     navigate(`/contracts/${uuid}`);
  //   };
  const relStatus = {
    1: (
      <span className="text-gray bg-light p-2 rounded" title="Link icon (gray)">
        <i class="bi bi-link-45deg"></i>
      </span>
    ),
    2: (
      <span
        className="text-primary bg-primary bg-opacity-25 p-2 rounded"
        title="Link icon (blue)"
      >
        <i class="bi bi-link-45deg"></i>
      </span>
    ),
    3: (
      <span className="text-gray bg-light p-2 rounded" title="$ icon (gray)">
        <i className="bi bi-currency-dollar"></i>
      </span>
    ),
    default: (
      <span className="text-muted" title="No relationship">
        -
      </span>
    ),
  };
  const textImage = {
    1: (
      <span className="text-gray bg-light p-2 rounded" title="Text icon (gray)">
        <i class="bi bi-fonts"></i>
      </span>
    ),
    2: (
      <span className="text-gray bg-light p-2 rounded" title="Text icon (gray)">
        <i class="bi bi-image"></i>
      </span>
    ),
  };
  const httpsStatusMessage = (statusCode) => {
    if (statusCode >= 200 && statusCode < 300) {
      return <span className="http_success">{statusCode}</span>;
    } else if (statusCode >= 400) {
      return <span className="http_failed">{statusCode}</span>;
    } else {
      return (
        <span className="http_unknown" style={{ color: "gray" }}>
          {statusCode}
        </span>
      );
    }
  };

  const LinkStatusType = {
    0: t("Draft"),
    1: t("Successful"),
    2: t("Page not found"),
    3: t("Backlink(s) not found"),
    4: t("Backlink type(s) changed"),
    5: t(
      'The page is preventing search indexing by implementing a "noindex" directive'
    ),
    6: t(
      'The page is preventing following links on this page by implementing a "nofollow" directive'
    ),
    7: t(
      'The page is preventing search indexing and following links on this page by implementing a "none" directive'
    ),
    8: t(
      'Provided page (or page after all redirects) URL pattern is part of the "Disallow" directive in a robots.txt file'
    ),
    9: t("Link's anchor changed"),
    10: t(
      'The page is preventing search indexing by setting up a "noindex" at the "X-Robots-Tag" header'
    ),
    11: t(
      'The page is preventing following links on this page by implementing a "nofollow" at the "X-Robots-Tag" header'
    ),
    12: t(
      'The page is preventing search indexing and following links on this page by implementing a "none" at the "X-Robots-Tag" header'
    ),
  };

  const localizeDate = (date) => {
    const localizeDateText = moment(date).format("MMM DD, YYYY");
    const mappings = {
      Jan: t("Jan"),
      Feb: t("Feb"),
      Mar: t("Mar"),
      Apr: t("Apr"),
      May: t("May"),
      Jun: t("Jun"),
      Jul: t("Jul"),
      Aug: t("Aug"),
      Sep: t("Sep"),
      Oct: t("Oct"),
      Nov: t("Nov"),
      Dec: t("Dec"),
    };

    // Replace text units with localized values
    return localizeDateText
      .split(" ")
      .map((word) => mappings[word] || word)
      .join(" ");
  };
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const getDynamicWidth = () => {
    if (windowWidth <= 375) {
      return window.innerWidth * 0.25; // For small screens (375px)
    } else if (windowWidth <= 576) {
      return window.innerWidth * 0.2; // For screens up to 576px
    } else if (windowWidth <= 786) {
      return window.innerWidth * 0.15; // For screens up to 786px
    } else if (windowWidth <= 1024) {
      return window.innerWidth * 0.19; // For screens up to 1024px
    } else if (windowWidth <= 1200) {
      return window.innerWidth * 0.19; // For screens up to 1200px
    } else if (windowWidth <= 1600) {
      return window.innerWidth * 0.17; // For screens up to 1600px
    } else {
      return window.innerWidth * 0.19; // For larger screens
    }
  };
  let tooltipInit = false;
  useEffect(() => {
    if (!tooltipInit) {
      const tooltipTriggerList = document.querySelectorAll(
        '[data-bs-toggle="tooltip"]'
      );
      [...tooltipTriggerList].forEach(
        (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
      tooltipInit = true;
    }
  }, [data, t]);

  const navigateToOpenDetails = (uuid) => {
    navigate(`/contracts/${uuid}`);
  };

  return (
    <div>
      <div style={{ display: "flex", width: "100%", gap: "2px" }}>
        {data && data?.length > 0 && (
          <div className="d-none d-md-block" style={{ width: "38%" }}>
            <table
              id="datatable-left"
              className="table table-borderless table-thead-bordered table-nowrap table-align-middle card-table"
              style={{ width: "100%" }}
            >
              <thead className="thead-light" style={{ height: "54px" }}>
                <tr>
                  <th className="monitor_header_table_left">
                    {t("BackLinks")}
                  </th>
                </tr>
              </thead>
              <ul class="list-group" className="monitor_table_left_list">
                {data?.map((item, index) => (
                  <li className="monitor_table_row list-group-item">
                    {columnsVisibility?.backlink && (
                      <div style={{ padding: "18px 0px 14px 15px" }}>
                        <span
                          style={{
                            display: "block",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: `${getDynamicWidth()}px`,
                            fontSize: "16px !important",
                            fontWeight: "600 !important",
                          }}
                          className="monitor_table_left_body_title"
                        >
                          {item?.donor?.page?.title || (
                            <div className="placeholder-glow">
                              <span className="placeholder col-12 skelten_placeholder"></span>
                            </div>
                          )}
                        </span>
                        <span
                          style={{
                            display: "block",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: `${getDynamicWidth()}px`,
                          }}
                          className="text-primary  monitor_table_left_body_title"
                        >
                          {item?.donor?.page?.status ? (
                            httpsStatusMessage(item?.donor?.page?.status)
                          ) : (
                            <span className="placeholder-glow">
                              <span className="placeholder col-2 skelten_placeholder"></span>
                            </span>
                          )}{" "}
                          <a
                            href={item?.donor?.page?.url}
                            className="text-primary monitor_table_left_body_title"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {item?.donor?.page?.url}
                          </a>
                        </span>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </table>
          </div>
        )}

        <div
          className="table-responsive datatable-custom"
          style={{ width: "100%" }}
        >
          <table
            id="datatable1"
            className="table table-lg table-borderless table-thead-bordered table-nowrap table-align-middle card-table"
            style={{ width: "100%" }}
          >
            <thead className="thead-light">
              <tr>
                {columnsHeader.map((column, index) => {
                  if (columnsVisibility[column.key]) {
                    const headerConfig = columnHeaderValue[column.key];
                    return (
                      <th
                        key={column.key}
                        style={headerConfig?.style}
                        className={
                          column?.isSort
                            ? `sorting${
                                !columnSorts[column?.sortingIndex]
                                  ? ""
                                  : columnSorts[column?.sortingIndex] === "asc"
                                  ? "_asc"
                                  : "_desc"
                              }`
                            : ""
                        }
                        onClick={
                          column?.isSort
                            ? () => setColumnSort(column?.sortingIndex)
                            : undefined // ✅ Prevent click handler if not sortable
                        }
                      >
                        <div
                          style={{
                            position: "relative",
                            display: "inline-block",
                          }}
                        >
                          <span style={{ paddingRight: "10px" }}>
                            {column.label}
                          </span>
                          {column?.icon && (
                            <span
                              style={{
                                position: "absolute",
                                top: "10",
                                right: "10",
                                transform: "translate(-23%, -33%)",
                                fontSize: "16px", // Adjust the icon size as needed
                                paddingRight: "20px",
                              }}
                            >
                              {column.icon}
                            </span>
                          )}
                        </div>
                      </th>
                    );
                  }
                  return null;
                })}
              </tr>
            </thead>
            <tbody className="monitor-table-body">
              {!!data?.length ? (
                data?.map((item, index) => {
                  return (
                    <tr key={index} className="monitor_table_row">
                      {columnsVisibility?.backlink && (
                        <td className="monitor-table-td">
                          <p>{item?.donor?.page?.title}</p>
                          <p className="text-primary">
                            {httpsStatusMessage(item?.donor?.page?.status)}{" "}
                            <a
                              href={item?.donor?.page?.url}
                              className="text-primary"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {item?.donor?.page?.url}
                            </a>
                          </p>
                        </td>
                      )}
                      {columnsVisibility?.indexed && (
                        <td>
                          {statusContent[item?.donor?.page?.indexed || null] ||
                            "-"}
                        </td>
                      )}
                      {columnsVisibility.price && (
                        <td>
                          {item?.contract?.links === 0 ||
                          item?.contract?.links === 1 ? (
                            `$${item?.contract?.price}` // Display full price if links are 0 or 1
                          ) : item?.contract?.links > 0 ? (
                            `$${(
                              item?.contract?.price / item?.contract?.links
                            ).toFixed(2)} / $${item?.contract?.price}`
                          ) : (
                            <button className="btn btn-primary">Add</button> // Show 'Add' button if links are null
                          )}
                        </td>
                      )}
                      {columnsVisibility.dr && (
                        <td>
                          {item?.donor?.domain?.stats?.find(
                            (stat) => stat?.provider === 1
                          )?.dr?.value || "-"}{" "}
                          {arrowIdentificaton(
                            item?.donor?.domain?.stats?.find(
                              (stat) => stat?.provider === 1
                            )?.dr?.change
                          )}
                        </td>
                      )}
                      {columnsVisibility.ur && (
                        <td>
                          {item?.donor?.domain?.stats?.find(
                            (stat) => stat?.provider === 1
                          )?.pr?.value || "-"}{" "}
                          {arrowIdentificaton(
                            item?.donor?.domain?.stats?.find(
                              (stat) => stat?.provider === 1
                            )?.pr?.change
                          )}
                        </td>
                      )}
                      {columnsVisibility.da && (
                        <td>
                          {item?.donor?.domain?.stats?.find(
                            (stat) => stat?.provider === 2
                          )?.dr?.value || "-"}{" "}
                          {arrowIdentificaton(
                            item?.donor?.domain?.stats?.find(
                              (stat) => stat?.provider === 2
                            )?.dr?.change
                          )}
                        </td>
                      )}
                      {columnsVisibility.pa && (
                        <td>
                          {item?.donor?.domain?.stats?.find(
                            (stat) => stat?.provider === 2
                          )?.pr?.value || "-"}{" "}
                          {arrowIdentificaton(
                            item?.donor?.domain?.stats?.find(
                              (stat) => stat?.provider === 2
                            )?.pr?.change
                          )}
                        </td>
                      )}
                      {columnsVisibility.traffic && (
                        <td>
                          {formatThousand(
                            item?.donor?.domain?.stats?.find(
                              (stat) => stat?.provider === 1
                            )?.traffic?.traffic?.value
                          ) || "-"}{" "}
                          {arrowIdentificaton(
                            item?.donor?.domain?.stats?.find(
                              (stat) => stat?.provider === 1
                            )?.traffic?.traffic?.change
                          )}
                        </td>
                      )}
                      {columnsVisibility.ext && (
                        <td>
                          {item?.donor?.page?.ext_links_from_page?.value || "-"}{" "}
                          {arrowIdentificaton(
                            item?.donor?.page?.ext_links_from_page?.change
                          )}
                        </td>
                      )}
                      {columnsVisibility.int && (
                        <td>
                          {item?.donor?.page?.int_links_from_page?.value || "-"}{" "}
                          {arrowIdentificaton(
                            item?.donor?.page?.int_links_from_page?.change
                          )}
                        </td>
                      )}
                      {columnsVisibility.target && (
                        <td>
                          <span
                            style={{
                              display: "block",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: `${getDynamicWidth()}px`,
                            }}
                            className="monitor_table_left_body_title"
                          >
                            {item?.target?.page?.title || (
                              <div className="placeholder-glow">
                                <span className="placeholder col-12 skelten_placeholder"></span>
                              </div>
                            )}
                          </span>
                          <span
                            style={{
                              display: "block",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: `${getDynamicWidth()}px`,
                            }}
                            className="text-primary monitor_table_left_body_title"
                          >
                            {item?.target?.page?.status ? (
                              httpsStatusMessage(item?.target?.page?.status)
                            ) : (
                              <span className="placeholder-glow">
                                <span className="placeholder col-2 skelten_placeholder"></span>
                              </span>
                            )}{" "}
                            <a
                              href={item?.target?.page?.url}
                              className="text-primary monitor_table_left_body_title"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {item?.target?.page?.url}
                            </a>
                          </span>
                        </td>
                      )}
                      {columnsVisibility.indexed && (
                        <td>
                          {statusContent[item?.target?.page?.indexed || null] ||
                            "-"}
                        </td>
                      )}
                      {columnsVisibility.status && (
                        <td className="">
                          {item?.status === 1 ? (
                            <div className="status_container status_actual">
                              <div>{t("Actual")}</div>
                            </div>
                          ) : (
                            <div className="status_container status_not_actual">
                              <div>{t("Not Actual")} </div>
                              <div
                                style={{
                                  cursor: "pointer",
                                  paddingBottom: "5px",
                                }}
                              >
                                <Mark
                                  height="16"
                                  width="16"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  title={LinkStatusType[item?.status] || ""}
                                />
                              </div>
                            </div>
                          )}
                        </td>
                      )}

                      {columnsVisibility.anchor ? (
                        <td>
                          {item?.anchor ? (
                            item?.anchor
                          ) : (
                            <div className="placeholder-glow">
                              <span className="placeholder col-12 skelten_placeholder"></span>
                            </div>
                          )}
                        </td>
                      ) : null}
                      {columnsVisibility.rel && (
                        <td>{relStatus[item?.rel] || relStatus.default}</td>
                      )}
                      {columnsVisibility.type && (
                        <td>{textImage[item?.type] || "-"}</td>
                      )}
                      {columnsVisibility.contract && (
                        <td
                          onClick={() =>
                            navigateToOpenDetails(item?.contract?.uuid)
                          }
                          className={`${
                            contractStatusType[item?.contract?.status]
                              ?.contractClass
                          } text-decoration-underline cursor-pointer`}
                        >
                          {item?.contract?.code || "-"}
                        </td>
                      )}
                      {columnsVisibility?.created && (
                        <td>{localizeDate(item?.created) || "-"}</td>
                      )}
                      {columnsVisibility.first_seen && (
                        <td>{localizeDate(item?.first_seen) || "-"}</td>
                      )}
                      {columnsVisibility.last_seen && (
                        <td>{localizeDate(item?.last_seen) || "-"}</td>
                      )}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td></td>
                  <td colSpan="100%">
                    <div
                      className="text-center p-4"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                        textAlign: "center",
                      }}
                    >
                      <img
                        className="mb-3"
                        src="https://static.articlesfactory.ai/app/svg/illustrations-light/oc-error.svg"
                        alt=""
                        style={{ width: "10rem" }}
                        data-hs-theme-appearance="dark"
                      />
                      <img
                        className="mb-3"
                        src="https://static.articlesfactory.ai/app/svg/illustrations/oc-error.svg"
                        alt=""
                        style={{ width: "10rem" }}
                        data-hs-theme-appearance="default"
                      />
                      <p className="mb-0">
                        {!data ? t("Loading data") : t("No data to show")}
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MonitorTable;
